<template>
    <v-card v-show="showForm" class="booking-comment-form elevation-0" rounded="0">
        <v-card-title>
            <v-icon start color="primary">mdi-comment-text</v-icon>
            {{ $t('comment') }}
        </v-card-title>
        <v-card-text>
            <div class="text-subtitle-2 text-info text-justify">
                {{ $t('notes.other_comment_note') }}
            </div>
            <v-form ref="form" v-model="valid" :disabled="disabled">
                <v-textarea
                    v-model="comment"
                    :placeholder="$t('type_here')"
                    rows="1"
                    :rules="[v => !v || v.length <= 1024 || $t('api_error_token.max_length_of_comment_is_1024')]"
                    variant="outlined"
                />
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class BookingCommentsForm extends Vue {
        @VModel({default: false}) valid
        @Prop() disabled
        @Prop() productStore

        get comment() {
            return this.productStore.prepareBookRequest.comments
        }

        set comment(val) {
            this.productStore.SET_PREPARE_BOOK_REQUEST_PROP({prop: 'comments', val})
        }

        get showForm() {
            return true
        }
    }

    export default BookingCommentsForm
</script>
